'use strict';

var Sugar = require('sugar-core');

require('./build/buildClassCheckMethodsCall');

module.exports = Sugar.Object.isBoolean;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/object/isBoolean.js
// module id = 808
// module chunks = 0